import { Result } from 'entities/result'
import { Background } from 'entities/background'
import _ from 'lodash'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type OvaryRiskScore = RiskScore & {
    height: number
    BMI: number
    endometriosis: number
    birth_count: number
    pill: number
    breast_cancer: number
    family: number
}
type OvaryRiskRatio = OvaryRiskScore

type OvaryResultInfoV2 = ResultInfoV2 & {
    risk_score: OvaryRiskScore
    risk_ratio: OvaryRiskRatio
    risk_data: RiskData<OvaryRiskScore>
}

export class OvaryResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, '卵巣がん', '0.1%程度', '1%程度', sample)
    }
    public info(): OvaryResultInfoV2 {
        return super.info() as OvaryResultInfoV2
    }

    private hasEndometriosis = (background: Background): boolean => {
        return background.medicalHistories?.some((mh) => mh.disease === 'endometriosis') ?? false
    }

    private hasBreast = (background: Background): boolean => {
        return background.medicalHistories?.some((mh) => mh.disease === 'breast') ?? false
    }

    public birth_count = () => {
        return `${this.background.birthCount}回`
    }

    public pill = () => {
        return `${this.background.yearsOfTakingPills}年`
    }

    public endometriosis = () => {
        return this.hasEndometriosis(this.background) ? '当てはまる' : '該当なし'
    }

    public breast_cancer = () => {
        return this.hasBreast(this.background) ? '当てはまる' : '該当なし'
    }

    public family = () => {
        const uniqCancers = _.uniq(this.background.familyHistories?.map((fh) => fh.cancer))
        if (uniqCancers.includes('breast') || uniqCancers.includes('ovary')) {
            return '当てはまる'
        } else {
            return '該当なし'
        }
    }

    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }

    public getMiddleTextPosition(): { bottom: number; left: number } {
        return { bottom: 145, left: 110 }
    }
    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }
}
